import React from 'react';
import styled from 'styled-components';
import { basedTechnology, platformScope, solutionScope } from './renewalData';
import {
  Block,
  BlockTitleSm,
  Card,
  Eyebrow,
  HairlineGrid,
  Inner,
  Lead,
  NumberBadge,
  SectionHead,
  SectionNo,
  SectionShell,
  SectionTitle,
  token,
} from './renewalStyles';

const TechTable = styled.div`
  border-top: 2px solid #000;
`;

const TechRow = styled.div`
  display: grid;
  grid-template-columns: minmax(140px, 220px) 1fr;
  gap: clamp(16px, 3vw, 48px);
  padding: 26px 0;
  border-bottom: 1px solid ${token.border};
  align-items: baseline;

  .cat {
    font-size: clamp(17px, 1.8vw, 22px);
    font-weight: 800;
  }

  .items {
    font-size: 16px;
    line-height: 1.7;
    color: ${token.ink2};
  }
`;

const ScopeCard = styled(Card)`
  padding: 40px 32px;

  .title {
    font-size: 22px;
    font-weight: 800;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 15px;
    line-height: 1.8;
    color: ${token.muted};
    white-space: pre-line;
  }
`;

const SolutionCard = styled(Card)`
  padding: 44px 36px;

  .title {
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 28px;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .name {
    font-size: 17px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .desc {
    font-size: 15px;
    color: ${token.muted};
    line-height: 1.7;
  }
`;

export default function Service() {
  return (
    <SectionShell id="service">
      <Inner>
        <SectionHead $gap="24px">
          <SectionNo>03</SectionNo>
          <SectionTitle>SERVICE</SectionTitle>
        </SectionHead>
        <Lead $max="860px">
          BRIT의 서비스 범위는 정해져 있지 않습니다. 클라이언트의 요구사항이 BRIT의 업무 범위입니다.
        </Lead>

        <Block $mb="120px">
          <Eyebrow>BASED TECHNOLOGY</Eyebrow>
          <BlockTitleSm>서비스 가능한 BRIT 기반 기술</BlockTitleSm>
          <TechTable>
            {basedTechnology.map(row => (
              <TechRow key={row.cat}>
                <div className="cat">{row.cat}</div>
                <div className="items">{row.items}</div>
              </TechRow>
            ))}
          </TechTable>
        </Block>

        <Block $mb="120px">
          <Eyebrow>SCOPE OF SERVICE</Eyebrow>
          <BlockTitleSm>플랫폼 개발 및 운영, 유지보수</BlockTitleSm>
          <HairlineGrid $min="280px" $line="#000" $weight="2px">
            {platformScope.map(item => (
              <ScopeCard key={item.no}>
                <NumberBadge>{item.no}</NumberBadge>
                <div className="title">{item.title}</div>
                <p>{item.desc}</p>
              </ScopeCard>
            ))}
          </HairlineGrid>
        </Block>

        <Block $mb="0">
          <Eyebrow>SCOPE OF SERVICE</Eyebrow>
          <BlockTitleSm>솔루션 사업 (외부, 자체)</BlockTitleSm>
          <HairlineGrid $min="340px" $line="#000" $weight="2px">
            {solutionScope.map(group => (
              <SolutionCard key={group.no}>
                <NumberBadge>{group.no}</NumberBadge>
                <div className="title">{group.title}</div>
                <div className="list">
                  {group.items.map(item => (
                    <div key={item.name}>
                      <div className="name">{item.name}</div>
                      {(item.desc || item.link) && (
                        <div className="desc">
                          {item.desc}
                          {item.link && (
                            <a href={item.link.href} target="_blank" rel="noopener noreferrer">
                              {item.link.label}
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </SolutionCard>
            ))}
          </HairlineGrid>
        </Block>
      </Inner>
    </SectionShell>
  );
}
